export const API_CONFIG = {
  API_KEY: process.env.REACT_APP_API_KEY || '17iHey9jM78K2fXVnWYzg5meJhxL4dNNa9EcPM55',
  BASE_URL: process.env.REACT_APP_API_URL || 'https://7bp159df88.execute-api.us-east-1.amazonaws.com/staging',
};

export const createApiClient = () => {
  const baseURL = API_CONFIG.BASE_URL;
  const apiKey = API_CONFIG.API_KEY;

  return {
    async request(method, path, body = null) {
      const options = {
        method,
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': apiKey,
        },
      };

      if (body) {
        options.body = JSON.stringify(body);
      }

      const response = await fetch(`${baseURL}${path}`, options);
      
      if (!response.ok) {
        const error = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(error.message || 'API request failed');
      }

      return response.json();
    },

    // Trips
    async listTrips(includeHidden = false) {
      const path = includeHidden ? '/trips?includeHidden=true' : '/trips';
      return this.request('GET', path);
    },
    async getTrip(tripId) {
      return this.request('GET', `/trips/${tripId}`);
    },
    async createTrip(data) {
      return this.request('POST', '/trips', data);
    },
    async updateTrip(tripId, data) {
      return this.request('PUT', `/trips/${tripId}`, data);
    },
    async deleteTrip(tripId) {
      return this.request('DELETE', `/trips/${tripId}`);
    },

    // Destinations
    async listDestinations(tripId, includeHidden = false) {
      const path = includeHidden
        ? `/trips/${tripId}/destinations?includeHidden=true`
        : `/trips/${tripId}/destinations`;
      return this.request('GET', path);
    },
    async getDestination(tripId, destId) {
      return this.request('GET', `/trips/${tripId}/destinations/${destId}`);
    },
    async createDestination(tripId, data) {
      return this.request('POST', `/trips/${tripId}/destinations`, data);
    },
    async updateDestination(tripId, destId, data) {
      return this.request('PUT', `/trips/${tripId}/destinations/${destId}`, data);
    },
    async deleteDestination(tripId, destId) {
      return this.request('DELETE', `/trips/${tripId}/destinations/${destId}`);
    },

    // Photos
    async listPhotos(tripId, destId) {
      return this.request('GET', `/trips/${tripId}/destinations/${destId}/photos`);
    },
    async getPresignedUrl(tripId, destId, fileName, s3FolderName) {
      return this.request('POST', `/trips/${tripId}/destinations/${destId}/photos/upload`, {
        fileName,
        s3FolderName,
      });
    },
    async createPhotoMetadata(tripId, destId, data) {
      return this.request('POST', `/trips/${tripId}/destinations/${destId}/photos`, data);
    },
    async deletePhoto(tripId, destId, photoId) {
      return this.request('DELETE', `/trips/${tripId}/destinations/${destId}/photos/${photoId}`);
    },
  };
};
